import { ComponentProps } from 'react'

import {
  Overview,
  type OverviewProps,
  RoomThumbnail,
  type TRecentViewedRoom,
} from '@/entities/room'
import { cn } from '@/shared/lib'

export type Props = ComponentProps<'a'> & {
  scaleThumbnail?: boolean
  room: Omit<OverviewProps, 'size'> &
    Partial<
      Pick<
        TRecentViewedRoom,
        'picMain' | 'isNew' | 'isSuperHost' | 'rid' | 'like'
      >
    >
}

export const RecentRoomItem = ({
  room,
  scaleThumbnail,
  ...restProps
}: Props) => {
  return (
    <a
      className="flex w-full flex-row justify-start gap-4 px-6 py-5"
      {...restProps}
    >
      <div className="relative">
        <RoomThumbnail
          src={room.picMain}
          alt={room.roomName}
          rounded
          size={100}
          ratio="1:1"
          imageClassName={cn(
            scaleThumbnail && 'scale-105 transition-all duration-300',
          )}
          blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8VA8AAkkBY8DEq9wAAAAASUVORK5CYII="
        />
      </div>
      <div>
        <Overview
          size="small"
          province={room.province}
          town={room.town}
          propertyType={room.propertyType}
          roomName={room.roomName}
          roomCnt={room.roomCnt}
          bathroomCnt={room.bathroomCnt}
          cookroomCnt={room.cookroomCnt}
          sittingroomCnt={room.sittingroomCnt}
          usingFee={room.usingFee}
          mgmtFee={room.mgmtFee}
        />
      </div>
    </a>
  )
}
